/* eslint-disable indent */
/* eslint-disable no-unsafe-optional-chaining */
/* eslint-disable no-unused-vars */
// React and Router
import React, {
  useEffect,
  useState,
  useCallback,
  useRef,
  useMemo,
} from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useReactToPrint } from "react-to-print";

import { InfoCircleOutlined } from "@ant-design/icons";
// Redux

// Third-party libraries
import Moment from "react-moment";
import moment from "moment";
import axios from "axios";
import "./index.scss";

// Ant Design
import {
  Col,
  Row,
  Select,
  Empty,
  Menu,
  Modal,
  Spin,
  Input,
  Button,
  message,
  DatePicker,
  Form,
  Divider,
  Tooltip,
  Table,
  Checkbox,
  Radio,
} from "antd";

// API and URLs
import API from "../../../../api";
import urls from "../../../../api/urls";

// Utils
import {
  getStartAndEndDate,
  getStartAndEndDate__,
  dateFormat_dmy,
  dateFormat_ymd,
  capitaliseWithHyphen,
  scrollToTop,
  formatReceiverAddress,
  splitReceiverName,
  getCurretRole,
  printingFileTemplate,
} from "../../../../utils";

// Components

import useCustomNavigate from "../../../../components/customNavigationHook";

// Assets
import search_icon from "../../../../assests/images/search-icon.svg";
import Smcs_Loader from "../../../../assests/images/loader-new.gif";
import discount_success from "../../../../assests/images/discountSuccess.png";

import { column } from "./column";
import DiscountModal from "./discountModal";
import { convertCurrentToPrevBookingData } from "../../../../utils/bookingDataConverter";
import ViewBookingSummary from "../../../ViewBookingSummary";
import InvoiceTable from "../../../FirstMile/InvoiceTable";
import PrintBooking from "../../../PrintBooking";

const {
  UPLOAD_MANIFEST_FILE,
  GET_DOCUMENT_DETAILS_BY_AWB,
  APPLY_DISCOUNT,
  RETAIL_DISCOUNT_LIST,
  RETAIL_DISCOUNT_RATE_CARD,
  RETAIL_DISCOUNT_SENDER_LIST,
  GET_COMPANY_DETAILS_NBA,
  GET_SINGEL_DOCUMENT_DETAILS_AWB_BE,
} = urls;

const { RangePicker } = DatePicker;

const DiscountBookingTable = ({ exportData = () => {}, userList }) => {
  const navigate = useCustomNavigate();
  const history = useLocation();
  const selectedCompany =
    JSON.parse(localStorage.getItem("selectedCompany")) || null;

  const [data, setData] = useState([]);

  const backHistory = history?.state?.credit;

  const [pageNum, setPageNum] = useState(
    backHistory ? history?.state?.pageNo : 0
  );
  const [pageSize, setPageSize] = useState(
    backHistory ? history?.state?.pageSize : 20
  );
  const [currentPage, setCurrentPage] = useState(
    backHistory ? history?.state?.pageNo + 1 : 1
  );

  const [total, setTotal] = useState(20);

  const debounceTimeout = useRef(null);
  const [searchValue, setSearchValue] = useState(null);
  const [loading, setLoading] = useState(false);
  const [filteredInfo, setFilteredInfo] = useState(null);
  const [clientList, setClientList] = useState([]);
  const [filteredClientOptions, setFilteredClientOptions] = useState([]);
  const currentEnv = process.env.REACT_APP_ENV;
  const [documentDetails, setDocumentDetails] = useState([]);

  const [companyDetails, setCompaniesDetails] = useState(null);

  const [dateRange, setDateRange] = useState(
    backHistory
      ? history?.state
      : {
          startDate: moment().subtract(1, "days").format(dateFormat_dmy),
          endDate: moment().format(dateFormat_dmy),
        }
  );

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [invoiceModalOpen, setInvoiceModalOpen] = useState(false);
  const [radioValue, setRadioValue] = useState();
  const [discountLoading, setDiscountLoading] = useState(false);
  const [selectedData, setSelectedData] = useState(null);

  const [senderList, setSenderList] = useState([]);

  const [summary, setSummary] = useState({
    totalAmount: 0,
    discountAmount: 0,
    sgst: 0,
    cgst: 0,
    igst: 0,
    cess: 0,
    finalAmount: 0,
    totalCharge: 0,
  });

  const getAllBookings = async ({
    pageNo,
    pageSize,
    startDate,
    endDate,
    search,
    senderName,
  }) => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "smooth",
    });
    setLoading(true);

    let url =
      `${RETAIL_DISCOUNT_LIST}?page=${
        senderName ? 1 : pageNo + 1
      }&limit=${pageSize}&companyId=${selectedCompany?.key}&status=${"DRAFT"}` +
      getStartAndEndDate__(
        startDate ? startDate : null,
        endDate ? endDate : null,
        dateFormat_ymd
      );

    let data = "account";

    // if (selectedCompany?.key) {
    //   url += `&branchId=${selectedCompany?.key}`;
    // }

    // if (data) {
    //   url += `&bookingType=${"account"}`;
    // }

    if (senderName) {
      url += `&senderName=${senderName}`;
    }

    let response = await API.Api(url).getWithHeader();

    if (response?.status) {
      setLoading(false);
      let result = response?.response?.data;
      // Sort shipments by document number in descending order

      setData(result?.shipments);
      let allClientNames = [];

      Object.entries(result.shipments).forEach(([name, clientData]) => {
        const clientNames = Object.keys(clientData);

        allClientNames.push(...clientNames.map((n) => n.trim()));

        clientData.shipments?.forEach((shipment) => {
          shipment.name = name.trim();
        });
      });

      // setSenderList(
      //   allClientNames.map((name) => ({ label: name, value: name }))
      // );

      setTotal(result?.totalPages || 3);
    } else {
      setLoading(false);
      message.error(
        response?.response?.data?.message || "Internal server error."
      );
    }
  };

  //   curl --location 'http://sandbox.bookingapis.innofulfill.com/shipment/senders/list?companyId=10171&startDate=2025-06-20&endDate=2025-06-24' \
  // --header 'accept: application/json'
  //  dateFormat_dmy

  const startDate = moment(dateRange?.startDate, "DD-MM-YYYY").format(
    dateFormat_ymd
  );
  const endDate = moment(dateRange?.endDate, "DD-MM-YYYY").format(
    dateFormat_ymd
  );

  useEffect(() => {
    senderListData();
  }, [startDate, endDate]);

  async function senderListData() {
    setLoading(true);
    let url = `${RETAIL_DISCOUNT_SENDER_LIST}?companyId=${selectedCompany?.key}&startDate=${startDate}&endDate=${endDate}`;
    let response = await API.Api(url).getWithHeader();
    if (response?.status) {
      setLoading(false);
      let senderList = response?.response?.data?.data;
      setSenderList(senderList.map((name) => ({ label: name, value: name })));
    } else {
      setLoading(false);
      // message.error(
      //   response?.response?.data?.message || "Internal server error."
      // );
    }
  }

  // console.log(senderList, "senderList");
  useEffect(() => {
    getAllBookings({ pageNo: 0, pageSize: 20 });
  }, []);

  function MyComponent(dateToFormat) {
    return (
      <>
        <Moment format="DD/MM/YYYY">{dateToFormat}</Moment>
        <br />
        <Moment format="hh:mm A">{dateToFormat}</Moment>
      </>
    );
  }

  const itemRender = (_, type, originalElement) => {
    if (type === "prev") {
      return <a>Previous</a>;
    }
    if (type === "next") {
      return <a>Next</a>;
    }
    return (
      <div>
        <p>{originalElement} </p>
      </div>
    );
  };

  /******************* Input search ******************************/

  const handleChangeSearch = (e) => {
    let currValue = e.target.value;
    if (currValue && isNaN(currValue)) {
      return;
    }
    setSearchValue(currValue);

    if (debounceTimeout.current) {
      clearTimeout(debounceTimeout.current);
    }

    debounceTimeout.current = setTimeout(async () => {
      let temp = {
        pageNo: 0,
        pageSize: 20,
        startDate: moment().subtract(30, "days"),
        endDate: moment(new Date(), dateFormat_dmy),
      };

      getAllBookings(temp);
    }, 900);
  };

  /******************* Type ******************************/

  function handlePageChange(pagination, filters, sorter) {
    setFilteredInfo(filters);
    window.scrollTo(0, 0);
    setRadioValue(null);

    setPageSize(20 || pagination?.pageSize);
    setPageNum(pagination?.current - 1);
    setCurrentPage(pagination?.current);

    getAllBookings({
      pageNo: pagination?.current - 1,
      pageSize: 20 || pagination?.pageSize,
    });
  }

  const disabledDate = (current) => {
    return current && current > moment().endOf("day");
  };

  const handleDateChange = (e, date) => {
    // e.preventDefault();
    setSearchValue(null);
    setDateRange({ startDate: date[0], endDate: date[1] });
    getAllBookings({
      pageNo: pageNum,
      pageSize: pageSize,
      startDate: date[0],
      endDate: date[1],
      senderName: searchValue || null,
    });
  };

  function handleClearSelect(params) {
    let temp = {
      pageNo: pageNum,
      pageSize,
      startDate: dateRange?.startDate,
      endDate: dateRange?.endDate,
    };

    getAllBookings(temp);
  }

  function handleEdit(id) {
    // localStorage.setItem("side_active", 3);
    // navigate("/retail-booking-edit/" + id);
    navigate("/retail-booking-edit/" + id, {
      state: {
        // ...allFilters,
        currentTab: "4",
        retail: true,
        credit: false,
        type: "discount",
      },
    });
  }

  useEffect(() => {
    if (radioValue && data) {
      const getData = data.find((item) => item[radioValue]);

      if (getData) {
        setSelectedData(Object.values(getData)[0]?.shipments);
      }
    }
  }, [radioValue, data]);

  const handleRadioChange = useCallback((clientName) => {
    setRadioValue(clientName);
  }, []);

  const handleEyeButton = (b) => {
    setIsSummaryModalOpen(true);
    getDetails(b?.documentNo);
  };

  const ClientTable = useCallback(
    ({ clientName, clientBookings, index, pagination, isLastTable }) => {
      const isDiscounted =
        Object.values(clientBookings)[0]?.isDiscountApplied || false;

      let shipmentsArray = [];
      let senderName = [];
      if (clientBookings) {
        Object.entries(clientBookings)?.forEach(([name, clientData]) => {
          shipmentsArray.push(...clientData.shipments);
          senderName.push(name);
        });
      }

      //{
      //     "id": 13,
      //     "invoiceUrl": "https://s3.ap-south-1.amazonaws.com/hubops-qa/SMILE",
      //     "createdAt": "2025-06-24T12:57:50.881Z",
      //     "updatedAt": "2025-06-24T12:57:50.881Z"
      // }
      let urls = shipmentsArray?.map(
        (item) => item?.discountInvoice?.invoiceUrl
      );

      // console.log(senderName, "senderName");

      return (
        <div>
          <div key={clientName} style={{ marginBottom: "20px" }}>
            <Table
              onChange={handlePageChange}
              columns={column({
                MyComponent,
                handleEdit,
                handleEyeButton,
                pageSize,
                loading,
                setLoading,
                pageNum,
                isDiscounted,
              })}
              scroll={{ x: 800 }}
              title={() =>
                isDiscounted ? (
                  <>
                    <div
                      className="d-flex"
                      // onClick={() => handleRadioChange(clientName)}
                      style={{
                        justifyContent: "space-between",
                        // cursor: "pointer",
                      }}
                    >
                      <div>
                        <>
                          <b> {senderName[0]?.toUpperCase()}</b>
                        </>
                      </div>
                      <div>
                        <Button
                          style={{ height: "32px" }}
                          type="primary"
                          onClick={() => {
                            if (urls[0]) {
                              window.open(urls[0], "_blank");
                            } else {
                              message.error("No invoice found");
                            }
                          }}
                          className="addPacketBtn ml-1"
                          loading={discountLoading}
                          // disabled={radioValue !== clientName}
                        >
                          DOWNLOAD INVOICE
                        </Button>
                      </div>
                    </div>
                  </>
                ) : (
                  <div
                    className="d-flex"
                    // onClick={() => handleRadioChange(clientName)}
                    style={{
                      justifyContent: "space-between",
                      // cursor: "pointer",
                    }}
                  >
                    <div>
                      <>
                        <span style={{ fontSize: "14px" }}>
                          {"Sender name:"}
                        </span>
                        <b> {senderName[0]?.toUpperCase()}</b>
                      </>
                    </div>
                    <div>
                      <Button
                        style={{ height: "32px" }}
                        type="primary"
                        onClick={() => {
                          handleRadioChange(senderName[0]);
                          handleModalOpen();
                        }}
                        className="addPacketBtn ml-1"
                        loading={discountLoading}
                        // disabled={radioValue !== clientName}
                      >
                        APPLY DISCOUNT
                      </Button>
                    </div>
                  </div>
                )
              }
              pagination={
                isLastTable
                  ? {
                      current: currentPage,
                      pageSize: 20,
                      total: total * 20,
                      itemRender: itemRender,
                      pageSizeOptions: ["20"],
                      showSizeChanger: false,
                    }
                  : false
              }
              headerClassName="header"
              className={`view-discount-table table-head-sticky ${
                isDiscounted ? "table-active" : ""
              }`}
              bordered
              dataSource={shipmentsArray || []}
            />
          </div>
        </div>
      );
    },
    [
      radioValue,
      handlePageChange,
      pageSize,
      pageNum,
      handleRadioChange,
      currentPage,
      data,
    ]
  );

  const renderClientTables = useCallback(() => {
    if (!data || Object.keys(data).length === 0) {
      return <Empty style={{ backgroundColor: "white", padding: "10vw" }} />;
    }

    const clientEntries = Object.entries(data);
    // console.log(clientEntries, "clientEntries");

    return clientEntries.map(([clientName, clientBookings], index) => (
      <ClientTable
        key={clientName}
        clientName={clientName}
        clientBookings={clientBookings}
        index={index}
        isLastTable={index === clientEntries.length - 1}
      />
    ));
  }, [data, ClientTable]);

  const memoizedClientTables = useMemo(
    () => renderClientTables(),
    [renderClientTables]
  );

  function handleModalOpen() {
    setIsModalOpen(true);
  }

  function handleModalClose() {
    setIsModalOpen(false);
  }
  function handleInvoiceModalOpen() {
    invoiceRef?.current?.downloadPDF();
    // setInvoiceModalOpen(true);
  }
  function handleInvoiceModalClose() {
    // handleLoading(false);
    let temp = {
      pageNo: pageNum,
      pageSize,
      startDate: dateRange?.startDate,
      endDate: dateRange?.endDate,
    };
    getAllBookings(temp);
    setRadioValue(null);
    setSummary({
      totalAmount: 0,
      discountAmount: 0,
      sgst: 0,
      cgst: 0,
      igst: 0,
      cess: 0,
      finalAmount: 0,
      totalCharge: 0,
    });
    setInvoiceModalOpen(false);
  }

  const handleClientSearch = (value) => {
    if (debounceTimeout.current) {
      clearTimeout(debounceTimeout.current);
    }

    debounceTimeout.current = setTimeout(() => {
      if (value?.length > 0) {
        const filtered = senderList?.filter((option) =>
          option?.label?.toLowerCase()?.includes(value?.toLowerCase())
        );
        setSenderList(filtered);
      } else {
        senderListData();
      }
    }, 100);
  };

  function handleDownloadInvoice() {
    invoiceRef?.current?.downloadPDF();
    // handleInvoiceModalClose();
  }
  const [isSummaryModalOpen, setIsSummaryModalOpen] = useState(false);
  const getDetails = async (id) => {
    setLoading(true);
    let url = `${GET_SINGEL_DOCUMENT_DETAILS_AWB_BE + +id}`;

    let response = await API.Api(url).getWithAllHeaders();
    if (response?.status) {
      setLoading(false);
      let extract = response?.response?.data?.data?.items;
      let convert = convertCurrentToPrevBookingData(extract);
      setDocumentDetails(convert);
    } else {
      setLoading(false);
      message.error(
        response?.response?.data?.message || "Internal server error."
      );
    }
  };

  function handleCancel() {
    setIsModalOpen(false);
    setIsSummaryModalOpen(false);
  }

  const getCompanyDetails = async () => {
    const company = JSON.parse(localStorage.getItem("selectedCompany")) || null;

    let res = await API.Api(GET_COMPANY_DETAILS_NBA + company?.key).get();
    setCompaniesDetails(res?.response?.data?.data);

    if (res.status) {
      const response = res?.response?.data?.data;
    } else {
      message.error(res?.response?.data?.message || "Internal server error.");
    }
  };

  useEffect(() => {
    getCompanyDetails();
  }, []);

  const invoiceRef = useRef();
  const componentRef = useRef();
  const [printDoc, setPrintDoc] = useState(null);

  function handleLoading(value) {
    setLoading(value);
  }

  const printHandle = useReactToPrint({
    content: () => componentRef.current,
    onBeforeGetContent: () => {
      setLoading(true);
    },
    onAfterPrint: () => {
      setLoading(false);
    },
    onPrintError: () => {
      setLoading(false);
      console.error("An error occurred while printing.");
    },
  });

  return (
    <Spin
      spinning={loading || discountLoading}
      indicator={
        <img src={Smcs_Loader} style={{ height: "100px", width: "100px" }} />
      }
    >
      <ViewBookingSummary
        visible={isSummaryModalOpen}
        loading={loading}
        // handleCancelBooking={handleCancelBooking}
        handleCancel={handleCancel}
        // allAppData={currentEnv == "qa" ? documentDetails : singleResult}
        allAppData={documentDetails}
        bookingType={"retail"}
      />

      <DiscountModal
        summary={summary}
        setSummary={setSummary}
        isModalOpen={isModalOpen}
        handleModalOpen={handleModalOpen}
        handleModalClose={handleModalClose}
        selectedData={selectedData}
        handleInvoiceModalOpen={handleInvoiceModalOpen}
        name={radioValue}
      />
      <Modal
        title={null}
        open={invoiceModalOpen}
        onCancel={handleInvoiceModalClose}
        footer={null}
        width={400}
        className="discount-modal"
      >
        <div style={{ textAlign: "center" }}>
          <div style={{ margin: " 20px 0" }}>
            <img src={discount_success} />
          </div>
          <div style={{ margin: " 20px 0" }}>
            <span style={{ fontSize: "18px", fontWeight: "bold" }}>
              Discount applied successfully!
            </span>
          </div>
          <Button
            className="addPacketBtn"
            type="primary"
            loading={loading}
            block
            style={{ width: "50%" }}
            onClick={() => {
              handleDownloadInvoice();
            }}
          >
            DOWNLOAD INVOICE
          </Button>
        </div>
      </Modal>
      <div
        className="view-discount-table-container"
        style={{
          display: "flex",
          justifyContent: "space-between",
          margin: "6px 6px",
          alignItems: "flex-end",
        }}
      >
        <div
          style={{
            display: "flex",
            // alignItems: "center",
            alignItems: "flex-end",
          }}
        >
          <div style={{ marginRight: 10 }}>
            <div style={{ fontSize: "14px", fontWeight: "bold" }}>
              Sender names
            </div>
            <Select
              allowClear
              onClear={() => {
                setRadioValue(null);
                handleClearSelect("client");
              }}
              className="listing-select-style"
              popupClassName="view-booking-clients-dropDown"
              style={{ width: "140px" }}
              placeholder="Select sender"
              showSearch
              onSearch={handleClientSearch}
              onSelect={(value) => {
                setSearchValue(value);
                let temp = {
                  pageNo: pageNum,
                  pageSize,
                  startDate: dateRange?.startDate,
                  endDate: dateRange?.endDate,
                  senderName: value,
                };
                getAllBookings(temp);
              }}
              filterOption={false}
              defaultActiveFirstOption
              options={senderList}
            />
          </div>

          {/* <div style={{ marginRight: 10 }}>
            <div style={{ fontSize: "14px", fontWeight: "bold" }}>
              Booking status
            </div>
            <Select
              allowClear
              className="listing-select-style"
              onClear={() => handleClearSelect("client")}
              popupClassName="view-booking-clients-dropDown"
              style={{ width: "140px" }}
              placeholder="Booking status"
              showSearch
              filterOption={(input, option) =>
                (option?.label ?? "")
                  .toLowerCase()
                  .includes(input.toLowerCase())
              }
              defaultActiveFirstOption
              options={[
                { label: "Pending ", value: "1" },
                { label: "Manifested", value: "2" },
              ]}
            />
          </div> */}

          <div style={{ marginRight: 10 }}>
            <RangePicker
              value={
                dateRange.startDate && dateRange.endDate
                  ? [
                      moment(dateRange.startDate, dateFormat_dmy),
                      moment(dateRange.endDate, dateFormat_dmy),
                    ]
                  : null
              }
              format={dateFormat_dmy}
              onClick={(e) => e.stopPropagation()}
              disabledDate={(current) => disabledDate(current)}
              onChange={handleDateChange}
              className="input-field-style"
              style={{ width: "240px", background: "white" }}
            />
          </div>
        </div>

        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "flex-end",
          }}
        >
          <div
            style={{
              backgroundColor: "#FFE8C9",
              padding: "7px",
              borderRadius: 10,
            }}
          >
            <span style={{ marginLeft: 5 }}>
              <Tooltip placement="right" title="">
                <InfoCircleOutlined />
              </Tooltip>
            </span>
            <span style={{ margin: "10px 5px" }}>
              Discount can be applied on minimum 5 bookings (Dox/Non-Dox) or
              weight above 5 kg
            </span>
          </div>

          <div
            style={{
              backgroundColor: "#FFE8C9",
              padding: "7px",
              borderRadius: 10,
              marginLeft: 10,
            }}
          >
            <span style={{ marginLeft: 5 }}>
              <Tooltip placement="right" title="">
                <InfoCircleOutlined />
              </Tooltip>
            </span>
            <span style={{ margin: "0 5px" }}>
              Upto 25% discount can be applied
            </span>
          </div>

          <div>
            {/* <Button
              style={{ height: "32px" }}
              type="primary"
              onClick={handleModalOpen}
              className="addPacketBtn ml-1"
              loading={discountLoading}
              disabled={!radioValue}
            >
              APPLY DISCOUNT
            </Button> */}
            {/* <Button
              style={{ height: "32px" }}
              type="primary"
              onClick={handleInvoiceModalOpen}
              className="addPacketBtn ml-1"
            >
              DOWNLOAD INVOICE
            </Button> */}
          </div>
        </div>
      </div>
      <div className="nba-table-container">
        <Row
          className="row-one align-center"
          style={{ display: "flex", justifyContent: "space-between" }}
        ></Row>
        {memoizedClientTables}
      </div>

      <div style={{ display: "none" }}>
        <PrintBooking
          ref={componentRef}
          id={printDoc}
          idList={[]}
          callPrint={() => printHandle()}
        />
      </div>
      {summary?.finalAmount > 0 && (
        <>
          <Button
            style={{ height: "32px" }}
            type="primary"
            onClick={handleInvoiceModalOpen}
            className="addPacketBtn ml-1"
          >
            DOWNLOAD INVOICE
          </Button>
          <InvoiceTable
            selectedData={selectedData}
            companyDetails={companyDetails}
            summary={summary}
            ref={invoiceRef}
            loading={loading}
            handleLoading={handleLoading}
            handleInvoiceModalClose={handleInvoiceModalClose}
          />
        </>
      )}
    </Spin>
  );
};

export default React.memo(DiscountBookingTable);
